import FieldFilter from './src/field_filter'

export default FieldFilter
